//  links with _blank
export function setupLinksWithTargetBlank() {
  var els = document.querySelectorAll("a[target=_blank");

  for (var i = 0; i < els.length; i++) {
    var el = els[i];
    processLink(el);
  }
}

function processLink(el) {
  var SUFFIX = " (otwiera w nowym oknie)";
  // zmienmy title na (otwiera w nowym oknie)
  var currenTitle = el.getAttribute("title") || String(el.textContent);
  var newTitle = currenTitle + SUFFIX;

  var currentAriaLabel =
    el.getAttribute("aria-label") || String(el.textContent);
  var newAriaLabel = currentAriaLabel + SUFFIX;

  el.setAttribute("title", newTitle);
  el.setAttribute("aria-label", newAriaLabel);

  // jesli to jest svg to trzeba tez zmienic title w svg
  var svg = el.querySelector("svg");
  if (svg) {
    var title = svg.querySelector("title");
    if (title) {
      title.textContent = title.textContent + SUFFIX;
    }
  }
}
